import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { FaArrowLeft } from "react-icons/fa";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import "../styles/AppStyles.css"; // Import the centralized CSS file

const OtherBenefitsList = () => {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchBdaId, setSearchBdaId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const PAGE_SIZE = 30;
  useEffect(() => {
    const fetchBenefits = async () => {
      const q = query(collection(db, "benefits"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      setBenefits(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    };
    fetchBenefits();
  }, []);
  const filteredBenefits = benefits.filter((b) =>
    searchBdaId
      ? (b.bdaId || "").toLowerCase().includes(searchBdaId.toLowerCase())
      : true
  );

  const totalPages = Math.ceil(filteredBenefits.length / PAGE_SIZE);

  const paginatedBenefits = filteredBenefits.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );
  const exportBenefits = () => {
    if (filteredBenefits.length === 0) {
      alert("No data to export");
      return;
    }

    const headers = [
      "Client ID",
      "Client Name",
      "BDA ID",
      "Plan Name",
      "Investment Amount",
      "One-Time Income",
      "Investment Date",
      "Remarks",
    ];

    const rows = filteredBenefits.map((b) => [
      b.clientId,
      b.clientName,
      b.bdaId,
      b.planName,
      b.investmentAmount,
      b.oneTimeIncome,
      b.investmentDate?.toDate().toLocaleDateString() || "",
      b.remarks || "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((r) => r.map((v) => `"${v}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "other_benefits_export.csv";
    link.click();
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-home">
      <div className="benefits-header">
        <h2>Other Benefits</h2>

        <Link to="/admin" className="back-button">
          <FaArrowLeft /> Back to Admin Panel
        </Link>
      </div>

      <div className="benefits-toolbar">
        <Link
          to="/admin/other-benefits/new"
          className="admin-button btnAdminHome"
        >
          Add Benefit Entry
        </Link>

        <input
          type="text"
          className="benefits-search"
          placeholder="Search by BDA ID"
          value={searchBdaId}
          onChange={(e) => {
            setSearchBdaId(e.target.value);
            setCurrentPage(1);
          }}
        />

        <button onClick={exportBenefits} className="admin-button">
          Export CSV
        </button>
      </div>

      <table className="transactions-table">
        <thead>
          <tr>
            <th>BDA ID</th>
            <th>Client ID</th>
            <th>Client Name</th>
            <th>Plan</th>
            <th>Investment Amount</th>
            <th>One-Time Income</th>
            <th>Investment Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedBenefits.map((b) => (
            <tr key={b.id}>
              <td>{b.bdaId}</td>
              <td>{b.clientId}</td>
              <td>{b.clientName}</td>
              <td>{b.planName}</td>
              <td>₹{b.investmentAmount}</td>
              <td>₹{b.oneTimeIncome}</td>
              <td>{b.investmentDate?.toDate().toLocaleDateString() || ""}</td>
              <td>
                <Link
                  to={`/admin/other-benefits/edit/${b.id}`}
                  className="btn btn-warning btn-sm"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default OtherBenefitsList;
